/**
 * URL의 item id가 activeId와 같다는 것만으로 hydration 완료로 보지 않는다.
 * 새로고침 직후 persist된 activeId만 남고 conversation entity가 비어 있을 수
 * 있으므로, entity 존재까지 함께 확인해야 개별 getItem fetch를 생략할 수 있다.
 */
export function isRouteConversationHydrated(
  itemId: string,
  activeId: string | null,
  conversations: Readonly<Record<string, unknown>>,
): boolean {
  return activeId === itemId && Boolean(conversations[itemId]);
}

export function isOrphanedRouteConversation(
  itemId: string,
  activeId: string | null,
  conversations: Readonly<Record<string, unknown>>,
): boolean {
  return activeId === itemId && !conversations[itemId];
}

export type RouteConversationHydrationAction =
  | 'hydrated'
  | 'activate-existing'
  | 'clear-orphan-and-fetch'
  | 'fetch';

export function resolveRouteConversationHydrationAction(
  itemId: string,
  activeId: string | null,
  conversations: Readonly<Record<string, unknown>>,
): RouteConversationHydrationAction {
  if (conversations[itemId]) {
    return activeId === itemId ? 'hydrated' : 'activate-existing';
  }
  return activeId === itemId ? 'clear-orphan-and-fetch' : 'fetch';
}

export function applyRouteConversationHydration(
  itemId: string,
  activeId: string | null,
  conversations: Readonly<Record<string, unknown>>,
  setActiveConversation: (
    id: string | null,
    options?: { syncMode?: boolean },
  ) => void,
): RouteConversationHydrationAction {
  const action = resolveRouteConversationHydrationAction(
    itemId,
    activeId,
    conversations,
  );
  if (action === 'clear-orphan-and-fetch') {
    setActiveConversation(null, { syncMode: false });
  } else if (action === 'activate-existing') {
    setActiveConversation(itemId);
  }
  return action;
}
